const imageUrl = (pathName = "") =>
  `${process.env.PUBLIC_URL}/images/${pathName}`;
export default imageUrl;
